import { BaseModal } from './base_modal.component';
import { WarningIcon } from 'components/icons/warning_icon.component';

interface InfoModalProps {
  id?: string;
  title: string;
  isOpen: boolean;
  hasCross?: boolean;
  children?: JSX.Element;
  onClose: () => void;
}

export function InfoModal( { id, title, isOpen, children, onClose, hasCross = true }: InfoModalProps ) {

  /*------------------------------- Front -------------------------------*/
  return (
    <BaseModal
      id={ id }
      title={ title }
      isOpen={ isOpen }
      onClose={ onClose }
      icon={ <WarningIcon className='w-10 p-2 fill-white'/> }
      iconColor='#4986f3'
      shadePourcent={ 0 }
      hasCross={ hasCross }
    >
      { children }
    </BaseModal>
  );
}